export default __webpack_public_path__ + "static/media/VANTEC20AARRAYBLANCO.138f4fd1.png";